<template>
  <ArrowBtn
    class="upgrade-button"
    :text="showText"
    :variant="'black-large'"
    @click.stop="handleClick"
  />
</template>

<script setup lang="ts">
import ArrowBtn from '@/pages/character/components/arrow-btn.vue';
import { useUpgrade } from '@rendora/common/features/upgrade-badge/useUpgrade';
import { ASSET_TYPE } from '@rendora/common/types/enums';
import { useI18n } from 'vue-i18n';
const { showUpgrade, onUpgrade } = useUpgrade();

const { t: $t } = useI18n();

const props = withDefaults(
  defineProps<{
    text: string;
    configType?: number;
    scene?: boolean;
  }>(),
  {
    configType: ASSET_TYPE.COMMON,
  },
);
const emit = defineEmits(['handle']);

const showText = computed(() =>
  showUpgrade(props.configType)
    ? props.scene
      ? $t('sheng-ji-quan-yi-jie-suo-ci-chang-jing')
      : $t('sheng-ji-quan-yi-jie-suo-ci-ren-wu')
    : props.text,
);

const handleClick = () => {
  // 展示升级付费弹窗
  if (showUpgrade(props.configType)) {
    onUpgrade(props.configType);
  } else {
    emit('handle');
  }
};
</script>

<style scoped lang="scss">
.upgrade-button {
  padding: 0 15px;
  // min-width: 270px !important;
}
</style>
